import { OverlineIconData, SvgIconType } from '@ahc-digital/component-library';
import { getKvpValue } from '@/shared/field-utils';
import { C35OverlineIconsRouteFields, OverlineTagItem } from './C35OverlineIcons.types';

const LOCATION_ICON: SvgIconType = 'mapMarkerAlt';

const TAG_FIELD_NAMES: Array<keyof C35OverlineIconsRouteFields> = [
  'Department Type',
  'Campus',
  'FacultyLabs',
  'Technology for License Type',
  'Technology for License Clinical Area',
];

function mapTagToOverlineIcon(tag?: OverlineTagItem): OverlineIconData | undefined {
  const icon = getKvpValue<SvgIconType | ''>(tag?.fields?.Icon);
  const text = tag?.fields?.['Tag Name']?.value;

  if (!icon || !text) return undefined;

  return {
    icon,
    text,
    type: icon === LOCATION_ICON ? 'location' : 'department',
  };
}

export function CreateC35OverlineIconsModel(
  fields?: C35OverlineIconsRouteFields
): ReadonlyArray<OverlineIconData> {
  return TAG_FIELD_NAMES.flatMap((fieldName) => fields?.[fieldName] ?? [])
    .map(mapTagToOverlineIcon)
    .filter((icon): icon is OverlineIconData => !!icon);
}
